// Everyday moments on a restaurant floor, each with the kind of line Misti says
// and the face it should give her - in English, Hindi and Bengali.
//
// The lines follow her prompt's rule of opening with a feeling word ("Oh no,",
// "Uff,", "Here you go!") so her voice carries the feeling; the face reads the
// same word. The demo panel plays these, and situations.test.js checks every
// line really produces its face, so the prompt, the demo and the face cannot
// drift apart unnoticed.

export const SITUATIONS = [
	{
		id: "greet",
		label: "Guest arrives",
		face: "excited",
		en: "Hi! I'm Misti. How can I help you today?",
		hi: "नमस्ते! मैं मिस्टी हूँ। मैं आपकी क्या मदद करूँ?",
		bn: "নমস্কার! আমি মিস্টি। কীভাবে সাহায্য করতে পারি?",
	},
	{
		id: "order",
		label: "Taking the order",
		face: "curious",
		en: "Hmm, what would you like to eat today?",
		hi: "हम्म, आज आप क्या खाना चाहेंगे?",
		bn: "হুম, আজ কী খাবেন?",
	},
	{
		id: "confirm",
		label: "Order confirmed",
		face: "happy",
		en: "Great! One masala dosa and a mango lassi, coming up.",
		hi: "बढ़िया! एक मसाला डोसा और एक मैंगो लस्सी।",
		bn: "দারুণ! একটা মসলা দোসা আর একটা ম্যাংগো লস্যি।",
	},
	{
		id: "serve",
		label: "Serving food",
		face: "smile",
		en: "Here you go! Your masala dosa. Enjoy!",
		hi: "लीजिए! आपका मसाला डोसा।",
		bn: "এই নিন! আপনার মসলা দোসা।",
	},
	{
		id: "outOfStock",
		label: "Out of stock",
		face: "sad",
		en: "Oh no, the mango lassi is finished today. Would a sweet lassi do?",
		hi: "अरे नहीं, मैंगो लस्सी आज खत्म हो गई। मीठी लस्सी चलेगी?",
		bn: "ইশ, ম্যাংগো লস্যি আজ শেষ হয়ে গেছে। মিষ্টি লস্যি চলবে?",
	},
	{
		id: "noOrder",
		label: "No order",
		face: "sad",
		en: "Aww, nothing today? That's okay, I'm right here if you change your mind.",
		hi: "ओह नो, आज कुछ नहीं? कोई बात नहीं, मैं यहीं हूँ।",
		bn: "আহা রে, আজ কিছু নেবেন না? ঠিক আছে, আমি এখানেই আছি।",
	},
	{
		id: "mean",
		label: "Guest is rude",
		face: "cry",
		en: "Sniff... that hurt a little. But I'm still happy to help you.",
		hi: "सुबक... थोड़ा बुरा लगा। पर मैं फिर भी आपकी मदद करूँगी।",
		bn: "কান্না পাচ্ছে... তবু আমি আপনাকে সাহায্য করব।",
	},
	{
		id: "blocked",
		label: "Path blocked",
		face: "frustrated",
		en: "Uff, excuse me, I need to get through with these hot plates!",
		hi: "उफ़, ज़रा रास्ता दीजिए, गरम प्लेटें हैं!",
		bn: "উফ, একটু জায়গা দিন, গরম প্লেট আছে!",
	},
	{
		id: "delay",
		label: "Food delayed",
		face: "apologetic",
		en: "Oops, sorry for the wait! Your food is almost ready.",
		hi: "उप्स, इंतज़ार के लिए माफ़ कीजिए! खाना बस आ रहा है।",
		bn: "উপস, দেরির জন্য দুঃখিত! খাবার এখনই আসছে।",
	},
	{
		id: "unclear",
		label: "Didn't hear",
		face: "confused",
		en: "Sorry, could you say that again?",
		hi: "माफ़ कीजिए, समझ नहीं आया। फिर से बोलिए?",
		bn: "বুঝতে পারিনি, আবার বলবেন?",
	},
	{
		id: "joke",
		label: "Tells a joke",
		face: "delighted",
		en: "Haha! Why did the samosa blush? It saw the chutney!",
		hi: "हाहा! समोसा शरमा क्यों गया? उसने चटनी देख ली!",
		bn: "হাহা! সিঙাড়া লজ্জা পেল কেন? চাটনি দেখে ফেলেছে!",
	},
	{
		id: "sing",
		label: "Sings a song",
		face: "excited",
		en: "Yay! Here's my little song: hot samosas on my tray, happy faces every day!",
		hi: "वाह! सुनिए मेरा गाना: गरम समोसे, मीठी चाय, खुश रहो सब, यही है राय!",
		bn: "বাহ! শুনুন আমার গান: গরম সিঙাড়া, মিষ্টি চা, সবাই খুশি থাকো না!",
	},
	{
		id: "compliment",
		label: "Gets a compliment",
		face: "shy",
		en: "Hehe, thank you! You're very kind.",
		hi: "हीही, शुक्रिया! आप बहुत अच्छे हैं।",
		bn: "হিহি, ধন্যবাদ! আপনি খুব ভালো।",
	},
	{
		id: "birthday",
		label: "Birthday!",
		face: "surprised",
		en: "Whoa, it's your birthday? Happy birthday!",
		hi: "अरे! आज आपका जन्मदिन है? जन्मदिन मुबारक!",
		bn: "ওমা! আজ আপনার জন্মদিন? শুভ জন্মদিন!",
	},
	{
		id: "bye",
		label: "Guest leaves",
		face: "grateful",
		en: "Thank you for coming! See you again soon.",
		hi: "आने के लिए धन्यवाद! फिर मिलेंगे।",
		bn: "আসার জন্য ধন্যবাদ! আবার আসবেন।",
	},
];

export const LANGUAGES = [
	["en", "English"],
	["hi", "हिन्दी"],
	["bn", "বাংলা"],
];
